import React, {Component} from 'react';
import {hashHistory} from 'react-router';
import {connect} from 'react-redux';
import {FormattedMessage} from "react-intl";

import {store} from '../../main';

import {modifyPageLayoutComponents} from '../PageLayout';
import VisualizerManagementHeaderTemplate from './VisualizerManagementHeader.rt';
import {AccessRights, PARTS} from '../../schemas/accessRightsModel';
import {toggle_modal} from "../../actions/A_Popups";

import {
  getDefaultPresets,
  setDefaultPresets,
  postDefaultPresets,
  setActiveDefaultPresetIndex, getPresetsName,
} from './VisualizerManagementActions';
import {errorBox_Show} from "../../actions/A_Popups";
import {hasSubscriptions} from "../../utilities/subscriptionFunctions";
import BlueDropDown from "../PageLayout/DropDowns/BlueDropDown";
import VisualizerManagementTabs from "./VisualizerManagementTabs";
import VisualizerManagementUiSwitch from "./VisualizerManagementUiSwitch";
import {AVAILABLE_VISUALIZERS, VISUALIZER_TYPES} from "../../constants/dashboard";
import TextInput from "../Generic/textInput";
import {VisualizerManagementMenu} from "./VisualizerManagementMenu";
import VisualizerManagementFooter from "./VisualizerManagementFooter";

export const VISUALIZER_MANAGEMENT_ACTIONS = {
  getState: "getState",
  checkState: "checkState",
  setState: "setState",
  visualizerIsLoaded: "visualizerIsLoaded",
  visualizerIsSaved: "visualizerIsSaved",
  closeVisualizerNavigation: "closeVisualizerNavigation",
}

class VisualizerManagement extends Component {

  componentDidMount() {
    console.log("VisualizerManagement mounted", );
    const {AR ,allSubscriptions} = this.props;
    let msg = [];
    if((!AR.v(PARTS.VIS_MNGM_BATH_DEF) && this.props.hasBathroom) && (!AR.v(PARTS.VIS_MNGM_KITCHEN_DEF) && this.props.hasKitchen)) {
      msg.push("Current user does not have permissions to manage visualizer settings.  Please log in as a user with proper permissions.");
    }
    if (!allSubscriptions.length) {
      msg.push("Account has no program type assigned. Please purchase a program type to manage visualizer settings.");
    }

    if(msg.length > 0) {
      this.props.errorBox_Show({
        title: 'Error',
        text: msg,
        rightButtonText: 'OK',
        isRightButtonVisible: true,
        callback: () => window.setTimeout(() => hashHistory.push('/'), 100)
      });
    }

    this.props.getDefaultPresets();
    window.addEventListener("message", this.setReceiveAndPostPresets);
  }

  getVisualizerIframeUrl = () => {
    const {activeTab, isProductJourney, subDomain} = this.props;
    if (window.location.port === "9005") {
      return "http://localhost:9007?defaults=true&visMgmt=1/#/" // we set all kvConfig locally
    }
    const server = window.location.protocol + "//" + subDomain + "." + window.location.host;
    const pathUrl = activeTab === "bathroom" ? "visualizer" : activeTab;
    return `${server}/${pathUrl}?visMgmt=1${isProductJourney?"&nav=product":""}`
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.setReceiveAndPostPresets);
  }

  setActiveDefaultPresetIndex = (activeDefaultPresetIndex, forTool = VISUALIZER_TYPES.bathroom, deleted = false) => {
    const {indexName} = getPresetsName(forTool);
    console.log('activeDefaultPresetIndex', activeDefaultPresetIndex);
    if ((this.props[indexName] !== activeDefaultPresetIndex) || deleted) {
      this.closeEverythingInsideVisualizer();
      window["next"+indexName] = activeDefaultPresetIndex; // temp save until message received;
      window.defaultPresetDeleted = deleted;
      this.refs.visualizerIframe.contentWindow.postMessage({
        action: VISUALIZER_MANAGEMENT_ACTIONS.checkState
      }, this.refs.visualizerIframe.src);
    }
  };

  handleSetPresetByTheDefault = (presetIndex, forTool = VISUALIZER_TYPES.bathroom) => {
    const presetName = getPresetsName(forTool).presetName;
    this.props.setDefaultPresets(this.props[presetName].map((preset, index) => {
      preset.loadByTheDefault = (presetIndex === index) ? !preset.loadByTheDefault : false;
      return preset
    }), forTool);
  };

  handleTogglePresetLock = (presetIndex, forTool = VISUALIZER_TYPES.bathroom) => {
    const presetsName = getPresetsName(forTool).presetName;
    this.props.setDefaultPresets(this.props[presetsName].map((preset, index) => {
      preset.presetUnlocked = (presetIndex === index) ? !!!preset.presetUnlocked : !!preset.presetUnlocked;
      return preset
    }), forTool);
  };

  addDefaultPreset = () => {
    const forTool = VISUALIZER_TYPES[this.props.activeTab] || VISUALIZER_TYPES.bathroom;
    const presetName = getPresetsName(forTool).presetName;
    this.props.setDefaultPresets([...this.props[presetName], {}], forTool);
    this.setActiveDefaultPresetIndex(this.props[presetName].length, forTool)
  };

  closeEverythingInsideVisualizer = () => {
    this.refs.visualizerIframe.contentWindow.postMessage({
      action: VISUALIZER_MANAGEMENT_ACTIONS.closeVisualizerNavigation
    }, this.refs.visualizerIframe.src);
  };

  setVisualizerState = (bvState) => {
    if (this.refs.visualizerIframe) {
      this.refs.visualizerIframe.contentWindow.postMessage({
        action: VISUALIZER_MANAGEMENT_ACTIONS.setState,
        bvState
      }, this.refs.visualizerIframe.src);
    }
  };

  setReceiveAndPostPresets = (event) => {
    // console.log('message to Dashboard arrived', event);
    const forTool = VISUALIZER_TYPES[this.props.activeTab] || VISUALIZER_TYPES.bathroom;
    const {presetName, indexName} = getPresetsName(forTool);
    const defaultPresets = store.getState().visualizerManagement[presetName];
    const activeDefaultPresetIndex = store.getState().visualizerManagement[indexName];

    if (event.data && (event.data.action === VISUALIZER_MANAGEMENT_ACTIONS.getState)) {
      // console.log('bvState event.data.payload', event.data.payload);
      // console.log('defaultPresets', defaultPresets);
      // console.log('this.state.activeDefaultPresetIndex', activeDefaultPresetIndex);
      // debugger;
      let presetsToPost = defaultPresets.length ? defaultPresets.map((defaultPreset, index) => {
        return activeDefaultPresetIndex == index ? Object.assign({}, {
          id: defaultPreset.id,
          lookId: defaultPreset.lookId,
          presetTitle: defaultPreset.presetTitle,
          presetPrice: defaultPreset.presetPrice,
          roomType: defaultPreset.roomType,
          loadByTheDefault: defaultPreset.loadByTheDefault,
        }, event.data.payload) : defaultPreset
      }) : [event.data.payload];
      presetsToPost = presetsToPost.map((preset, index) => {
        preset.loadByTheDefault = this.props[presetName][index].loadByTheDefault;
        preset.presetUnlocked = this.props[presetName][index].presetUnlocked;
        return preset
      });
      this.props.postDefaultPresets(presetsToPost, false, forTool);
    }
    if (event.data && (event.data.action === VISUALIZER_MANAGEMENT_ACTIONS.checkState)) {
      const currentChanges = event.data.payload;
      const objectToCompare1 = Object.assign({}, currentChanges);
      const objectToCompare2 = Object.assign({}, defaultPresets[activeDefaultPresetIndex]);
      objectToCompare1.bv_screen = null;
      objectToCompare2.bv_screen = null;
      // console.log('objectToCompare1', objectToCompare1);
      // console.log('objectToCompare2', objectToCompare2);
      // debugger;
      if ((JSON.stringify(objectToCompare1) === JSON.stringify(objectToCompare2)) || window.defaultPresetDeleted) {
        this.props.setActiveDefaultPresetIndex(window["next"+indexName], forTool);
        this.setVisualizerState(defaultPresets[window["next"+indexName]]);
        window["next"+indexName] = null;
        window.defaultPresetDeleted = false;
      } else {
        this.askIfYouWantToChange(currentChanges, forTool);
      }
    }
    // if (event.data && (event.data.action === VISUALIZER_MANAGEMENT_ACTIONS.visualizerIsLoaded)) {
      //  // removed to test technically, we have default preset apply already, let's try
      // console.log('this.props.defaultPresets[0]', this.props.defaultPresets[0]);
      // this.setVisualizerState(defaultPresets[activeDefaultPresetIndex])
    // }
  };

  askIfYouWantToChange = (currentChanges, forTool = VISUALIZER_TYPES.bathroom) => {
    const {presetName, indexName} = getPresetsName(forTool);
    this.props.toggle_modal(true, "Would you like to save the changes to the Display Room you created?", [
      {
        text: "NO",
        color: "blue",
        onClick: () => {
          this.props.setActiveDefaultPresetIndex(window["next"+indexName], forTool);
          this.setVisualizerState(this.props[presetName][window["next"+indexName]]);
          this.props.toggle_modal(false);
          window["next"+indexName] = null;
          window.defaultPresetDeleted = false;
        }
      },
      {
        text: "YES",
        color: "green",
        onClick: () => {
          let presetsToPost = this.props[presetName].length ? this.props[presetName].map((defaultPreset, index) => {
            if (this.props[indexName] == index) {
              ["id", "lookId", "presetTitle", "presetPrice", "roomType"].forEach(property => {
                currentChanges[property] = defaultPreset[property];
              })
              return currentChanges
            }
            return defaultPreset
          }) : [currentChanges]; // should not ever be here! just in case
          presetsToPost = presetsToPost.map((preset, index) => {
            preset.loadByTheDefault = this.props[presetName][index].loadByTheDefault;
            return preset
          });
          this.props.postDefaultPresets(presetsToPost, false, forTool, () => {
            this.props.setActiveDefaultPresetIndex(window["next"+indexName], forTool);
            this.setVisualizerState(this.props[presetName][window["next"+indexName]]);
            this.props.toggle_modal(false);
            window["next"+indexName] = null;
            window.defaultPresetDeleted = false;
          });
        }
      }
    ]);
  };

  handleDeletePreset = () => {
    const forTool = VISUALIZER_TYPES[this.props.activeTab] || VISUALIZER_TYPES.bathroom;
    this.closeEverythingInsideVisualizer();
    this.props.toggle_modal(true, "Are you sure you want to delete this preset?", [
      {
        text: "NO",
        color: "blue",
        onClick: () => {
          this.props.toggle_modal(false)
        }
      },
      {
        text: "YES",
        color: "green",
        onClick: () => {
          this.props.toggle_modal(false);
          const {presetName, indexName} = getPresetsName(forTool);
          const defaultPresets = this.props[presetName];
          defaultPresets.splice(this.props[indexName], 1);
          this.props.postDefaultPresets(defaultPresets, true, forTool);
          const nextActivePresetIndex = this.props[indexName] - 1;  //TODO nextActivePresetIndex
          this.setActiveDefaultPresetIndex(
            nextActivePresetIndex > -1 ? nextActivePresetIndex : 0,
            forTool,
            true
          );
        }
      }
    ]);
  };

  setPresetProperty = (property, value, presetIndex, forTool = VISUALIZER_TYPES.bathroom, applyOnAll = false) => {
    const presetName = getPresetsName(forTool).presetName;
    if (!applyOnAll && (this.props[presetName][presetIndex] && this.props[presetName][presetIndex][property] === value)) {
      return false
    }
    if ((property === "id") && this.props[presetName].some((currentPreset, currentPresetIndex) => {
      return currentPreset.id === value && currentPresetIndex !== presetIndex
    })) {
      this.props.toggle_modal(true, `ID ${value} already exist`);
      return false
    }
    console.log("name", property);
    console.log("value", value);
    this.props.setDefaultPresets(this.props[presetName].map((preset, index) => {
      if (applyOnAll || presetIndex === index) {
        preset[property] = value;
        if (property === "roomType" && presetIndex === index && (!preset.roomType || (preset.roomType !== value))) {
          preset.roomType = value;
          this.setVisualizerState(preset); // update room type in the visualizer!
        }
      }
      return preset
    }), forTool);
  }

  getVmItemThumbnail = (presetIndex, forTool = VISUALIZER_TYPES.bathroom) => {
    const presetName = getPresetsName(forTool).presetName;
    const bv_screen = this.props[presetName][presetIndex].bv_screen;
    return bv_screen ? "url(" + bv_screen + ")" : ""
  };

  callRoomTypeQuestionModal = (roomType, preset, presetIndex) => {
    this.props.toggle_modal(true, "Are you sure you want to change the room type?", [{
      text: "NO",
      color: "blue",
      onClick: () => this.props.toggle_modal(false)
    }, {
      text: "YES",
      color: "green",
      onClick: () => {
        this.props.toggle_modal(false);
        this.setPresetProperty('roomType', roomType.value, presetIndex, 'bv')
      }
    }, {
      text: "YES, APPLY ON ALL",
      color: "green",
      onClick: () => {
        this.props.toggle_modal(false);
        this.setPresetProperty('roomType', roomType.value, 0, 'bv', true)
      }
    }]);
  };

  renderRoomTypeDropdown = (preset, presetIndex) => {
    const roomTypeValues = [{
      // text: intl.formatMessage({id: "wizard.subscription." + sub.service}),
      text: "as",
      value: "americanstandard",
    }, {
      // text: intl.formatMessage({id: "wizard.subscription." + sub.service}),
      text: "grohe",
      value: "grohe",
    }];
    return (
      <BlueDropDown items={roomTypeValues}
                    onItemClick={(item) => this.callRoomTypeQuestionModal(item, preset, presetIndex)}
                    selectedItem={roomTypeValues.find(sub=> sub.value === preset.roomType) || roomTypeValues[1]}
                    itemKey={(item) => item.text}
                    itemValue={(item) => item.text}/>
    )
  }

  render = () => {
    const {AR, allSubscriptions, activeTab} = this.props;

    return (
      <div className="app-content-main">
        <div className="visualizer-management">
          <VisualizerManagementTabs/>
          <VisualizerManagementUiSwitch/>
          <div className="visualizer-management-table">
            <div className="visualizer-management-list">
              {allSubscriptions.map(visualizer => {
                if (activeTab !== visualizer) {
                  return null
                }
                if (visualizer === AVAILABLE_VISUALIZERS.bathroom && !AR.v(PARTS.VIS_MNGM_BATH_DEF)) {
                  return null
                }
                if (visualizer === AVAILABLE_VISUALIZERS.kitchen && !AR.v(PARTS.VIS_MNGM_KITCHEN_DEF)) {
                  return null
                }
                const forTool = VISUALIZER_TYPES[activeTab];
                const {presetName, indexName} = getPresetsName(forTool);
                return (
                  <div className="visualizer-management-list__item visualizer" key={visualizer}>
                    <div className="visualizer-title">
                      <span><FormattedMessage id={"wizard.subscription." + visualizer}/> Visualizer</span>
                    </div>
                    <div className="visualizer-content">
                      <iframe id="visualizerIframe"
                              ref="visualizerIframe"
                              className="visualizer-content__iframe"
                              src={this.getVisualizerIframeUrl()}
                              width="100%"
                              height="1080px"
                              frameBorder="0">
                      </iframe>
                    </div>
                    <ul className="visualizer-list">
                      {this.props[presetName].map((preset, presetIndex) => {
                        const isActive = this.props[indexName] === presetIndex;
                        return (
                          <li className={"visualizer-list__item visualizer-list__item--" + (isActive ? "active" : "inactive")
                            + " visualizer-list__item--" + visualizer}
                              key={presetIndex}>
                            <div className="visualizer-list__item-image"
                                 onClick={() => this.setActiveDefaultPresetIndex(presetIndex, forTool)}
                                 style={{'backgroundImage': this.getVmItemThumbnail(presetIndex, forTool)}}>
                              <span className={"ui-star ui-star--white visualizer-list__item-star"
                                + (preset.loadByTheDefault ? " ui-star--active" : "")}
                                    onClick={() => this.handleSetPresetByTheDefault(presetIndex, forTool)}>
                                 {preset.loadByTheDefault ? "Default" : "Make Default"}
                              </span>
                              <span className={"ui-icon-lock2 visualizer-list__item-lock" + (preset.presetUnlocked ? "" : " ui-icon-lock2--locked")}
                                    onClick={() => this.handleTogglePresetLock(presetIndex, forTool)}/>
                              {isActive ? <button className="ui-icon-remove2 fc-gallery__list-item-remove"
                                                  onClick={this.handleDeletePreset}/> : null}
                            </div>
                            <div className="visualizer-list__item-content ui-darkline">
                              {visualizer === AVAILABLE_VISUALIZERS.bathroom && (preset.version >= 6 || preset.toolVersion >= 6) ? (
                                <div className="visualizer-list__item-content-block">
                                  <span className="visualizer-list__item-content-block-label">Type:</span>
                                  <div className="visualizer-list__item-content-block-value">
                                    {this.renderRoomTypeDropdown(preset, presetIndex)}
                                  </div>
                                </div>
                              ) : null}
                              <div className="visualizer-list__item-content-block">
                                <span className="visualizer-list__item-content-block-label">Id:</span>
                                <div className="visualizer-list__item-content-block-value">
                                  <TextInput className="discount-name"
                                             numberInput={true}
                                             onChange={(value) => this.setPresetProperty('id', value, presetIndex, forTool)}
                                             value={Number.isInteger(preset.id) ? preset.id + '' : ''} />
                                </div>
                              </div>
                              <div className="visualizer-list__item-content-block">
                                <span className="visualizer-list__item-content-block-label">Look Id:</span>
                                <div className="visualizer-list__item-content-block-value">
                                  <TextInput className="discount-name"
                                             numberInput={true}
                                             onChange={(value) => this.setPresetProperty('lookId', value, presetIndex, forTool)}
                                             value={Number.isInteger(preset.lookId) ? preset.lookId + '' : ''} />
                                </div>
                              </div>
                              <div className="visualizer-list__item-content-block">
                                <span className="visualizer-list__item-content-block-label">Name:</span>
                                <div className="visualizer-list__item-content-block-value">
                                  <TextInput className="discount-name"
                                             onChange={(value) => this.setPresetProperty('presetTitle', value, presetIndex, forTool)}
                                             value={preset.presetTitle || ''} />
                                </div>
                              </div>
                              <div className="visualizer-list__item-content-block">
                                <span className="visualizer-list__item-content-block-label">Price:</span>
                                <div className="visualizer-list__item-content-block-value">
                                  <TextInput className="discount-name"
                                             numberInput={true}
                                             onChange={(value) => this.setPresetProperty('presetPrice', value, presetIndex, forTool)}
                                             value={preset.presetPrice ? preset.presetPrice + '' : ''} />
                                </div>
                              </div>
                            </div>
                          </li>
                        )
                      })}
                      <li className="visualizer-list__item visualizer-list__item--empty" onClick={this.addDefaultPreset}>
                        <span className="visualizer-list__item-add">
                          <span className="visualizer-list__item-add-text">Add Room Configuration</span>
                        </span>
                      </li>
                    </ul>
                  </div>
                )
              })}
            </div>
            {activeTab === "mobile_links" ? <VisualizerManagementMenu/> : null}
          </div>
        </div>
      </div>
    )
  }

}

const mapStateToProps = state => {
  const {auth, asCustomer} = state;
  const AR = AccessRights.get(state);
  const {hasKitchen, hasBathroom, allSubscriptions} = hasSubscriptions(state);
  const {activeTab, isProductJourney} = state.visualizerManagement;
  return {
    fabricatorId: auth.fabricator,
    subDomain: asCustomer.data && asCustomer.data.subDomain ? asCustomer.data.subDomain : auth.subDomain,
    AR,
    defaultBvPresets: state.visualizerManagement.defaultBvPresets,
    defaultKvPresets: state.visualizerManagement.defaultKvPresets,
    defaultFpPresets: state.visualizerManagement.defaultFpPresets,
    defaultLrPresets: state.visualizerManagement.defaultLrPresets,
    activeDefaultBvPresetIndex: state.visualizerManagement.activeDefaultBvPresetIndex,
    activeDefaultKvPresetIndex: state.visualizerManagement.activeDefaultKvPresetIndex,
    activeDefaultFpPresetIndex: state.visualizerManagement.activeDefaultFpPresetIndex,
    activeDefaultLrPresetIndex: state.visualizerManagement.activeDefaultLrPresetIndex,
    hasKitchen,
    hasBathroom,
    activeTab,
    isProductJourney,
    allSubscriptions,
  }
};

const mapDispatchToProps = dispatch => ({
  errorBox_Show: config => dispatch(errorBox_Show(config)),
  getDefaultPresets: () => dispatch(getDefaultPresets()),
  postDefaultPresets: (presetsArray, deleting, forTool, callback) => {
    return dispatch(postDefaultPresets(presetsArray, deleting, forTool, callback))
  },
  setActiveDefaultPresetIndex: (activeDefaultPresetIndex, forTool) => {
    return dispatch(setActiveDefaultPresetIndex(activeDefaultPresetIndex, forTool))
  },
  setDefaultPresets: (presetsArray, forTool) => dispatch(setDefaultPresets(presetsArray, forTool)),
  toggle_modal: (visible, message, buttons) => dispatch(toggle_modal(visible, message, buttons)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export const VisualizerManagementLayoutComponents = modifyPageLayoutComponents({
  pageHeader: connector(VisualizerManagementHeaderTemplate),
  content: connector(VisualizerManagement),
  pageFooter: VisualizerManagementFooter
});

